import { render, staticRenderFns } from "./CMFilters.vue?vue&type=template&id=1f615ae4&scoped=true&lang=pug"
import script from "./CMFilters.vue?vue&type=script&lang=js"
export * from "./CMFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f615ae4",
  null
  
)

export default component.exports